import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ArrowBackIosRounded, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import "./carousel-home.scss";
import { Service } from "./carousel-home.types";
import { getServices } from "../../../api/homepage.api";
import CarouselCard from "./carousel-card";
import { getCategories } from "../../../api/admin/service-management";

export default function CarouselHome({ categories: categoriesProp }: { categories: any[] }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const itemsToShow = isXs ? 1 : isSm ? 2 : 3;
  const navigate = useNavigate();
  const [services, setServices] = useState<Service[]>([]);
  const [startIndex, setStartIndex] = useState(0);
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    if (categoriesProp && categoriesProp.length > 0) {
      setCategories(categoriesProp);
    }
  }, [categoriesProp]);

  const isAtEnd = startIndex + itemsToShow >= categories?.length;

  const handlePrevSlide = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNextSlide = () => {
    setStartIndex((prev) =>
      Math.min(prev + 1, categories.length - itemsToShow),
    );
  };

  // const handleCarouselClick = (serviceId: number, needType: string) => {
  //   navigate("/home/list-of-funeral-homes", {
  //     state: {
  //       selectedServiceId: serviceId,
  //       selectedNeedType: needType === "at_need" ? "immediate" : "pre_need",
  //     },
  //   });
  // };

  const handleCarouselClick = (categoryId: number, needType: string) => {
    navigate("/home/list-of-funeral-homes", {
      state: {
        selectedCategoryId: categoryId,
        selectedNeedType: needType === "at_need" ? "immediate" : "pre_need",
      },
    });
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await getServices("all");

        const typeOfServices = response.data.data.data;

        setServices(typeOfServices || []);
      } catch (error) {
        console.error("Failed to fetch services:", error);
      }
    };

    // fetchServices();
  }, []);



  return (
    <Box
      component="section"
      className="third-section carousel-section"
      sx={{ py: { xs: 3, md: 6 }, backgroundColor: "#EAE9EF" }}
    >
      <Container maxWidth="xl">
        <Typography
          variant="h4"
          component="h1"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "32px", lg: "34px" },
            lineHeight: { xs: "28px", md: "36px", lg: "40px" },
            color: "#104145",
          }}
        >
          What <span style={{ color: "#9F7F2C" }}>We Do</span>
        </Typography>
        <Typography
          className="carousel-section__subheading"
          sx={{
            textAlign: "center",
            mb: 3,
            fontWeight: 400,
            fontSize: { xs: "28px", sm: "36px", md: "60px" },
          }}
        >
          Explore Trusted Funeral &amp;&nbsp;
          <span style={{ color: "#9F7F2C" }}>Memorial Services</span>
        </Typography>

        <Box
          className="carousel-wrapper"
          sx={{
            position: "relative",
            maxWidth: 1210,
            mx: "auto",
            overflow: "hidden",
          }}
        >
          <Box
            className="carousel-track"
            sx={{
              display: "flex",
              transform: `translateX(-${startIndex * (100 / itemsToShow)}%)`,
              transition: "transform 0.2s ease-in-out",
              maxWidth: !isAtEnd ? { md: "95%" } : { md: "100%" },
            }}
          >
            {categories?.map((category, index) => (
              <Grid
                item
                xs={12}
                sm={4}
                key={index}
                className="carousel-item"
                sx={{ flex: `0 0 ${100 / itemsToShow}%` }}
              >
                <CarouselCard
                  category={category}
                  onClick={() =>
                    handleCarouselClick(category.id, category.needTypes[0])
                  }
                />
              </Grid>
            ))}
          </Box>

          {categories?.length > itemsToShow && (
            <>
              <IconButton
                className="carousel-arrow carousel-arrow--left"
                onClick={handlePrevSlide}
                disabled={startIndex === 0}
                sx={{
                  position: "absolute",
                  left: -2,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#fff",
                  backgroundColor: "#104145",
                  border: "1px solid #ffffff",
                  zIndex: 10,
                  marginLeft: "1.2rem",
                  "&:disabled": {
                    backgroundColor: "#5a5a5a",
                    color: "#ccc",
                    borderColor: "#ccc",
                    opacity: 0.5,
                    cursor: "not-allowed",
                  },
                  "&.Mui-disabled": {
                    pointerEvents: "auto",
                    cursor: "not-allowed",
                  },
                }}
              >
                <ArrowBackIosRounded />
              </IconButton>

              <IconButton
                className="carousel-arrow carousel-arrow--right"
                onClick={handleNextSlide}
                disabled={startIndex >= categories?.length - itemsToShow}
                sx={{
                  position: "absolute",
                  right: -2,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#fff",
                  backgroundColor: "#104145",
                  boxShadow: "0px 0px 5px 3px rgba(0, 0, 0, 0.2) !important",
                  border: "1px solid #ffffff",
                  zIndex: 10,
                  marginRight: !isAtEnd ? { md: "0.3rem" } : { md: "1.2rem" },
                  "&:disabled": {
                    backgroundColor: "#5a5a5a",
                    color: "#ccc",
                    borderColor: "#ccc",
                    opacity: 0.5,
                  },
                  "&.Mui-disabled": {
                    pointerEvents: "auto",
                    cursor: "not-allowed",
                  },
                }}
              >
                <ArrowForwardIos />
              </IconButton>
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
}
